<rt-confirm-dialog
  [title]="'app.block_password_change_dialog.header' | translate"
  [variant]="ConfirmDialogVariant.Information"
  [safeFooter]="false"
  [agreeLabel]="'app.block_password_change_dialog.footer' | translate"
  [cancelLabel]="'app.common.cancel' | translate"
  [triggerUpdateOnInit]="true"
>
  <p [innerHTML]="'app.block_password_change_dialog.body_html' | translate"></p>
</rt-confirm-dialog>
